//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";

export default {
    name: "QfPAlignment",
    data() {
        return {
            verticalAlign: null,
            horizontalAlign: null,
            horizontalAlignOptions: [
                { key: "hleft", value: "left", icon: "mdi-format-horizontal-align-left" },
                { key: "hcenter", value: "center", icon: "mdi-format-horizontal-align-center" },
                { key: "hright", value: "right", icon: "mdi-format-horizontal-align-right" }
            ],
            verticalAlignOptions: [
                { key: "vtop", value: "top", icon: "mdi-format-vertical-align-top" },
                { key: "vcenter", value: "center", icon: "mdi-format-vertical-align-center" },
                { key: "vbottom", value: "bottom", icon: "mdi-format-vertical-align-bottom" }
            ],
            componentGenerics: null
        };
    },
    computed: {
        ...mapState("components", ["properties", "activeComponent"])
    },
    watch: {
        activeComponent: {
            handler(val) {
                this.componentGenerics = this.properties[val].__generics;
                this.verticalAlign = this.componentGenerics.vAlign || null;
                this.horizontalAlign = this.componentGenerics.hAlign || null;
            },
            immediate: true
        }
    },
    methods: {
        updateVertical(value) {
            this.verticalAlign = value;
            this.componentGenerics.vAlign = value;
        },
        updateHorizontal(value) {
            this.horizontalAlign = value;
            this.componentGenerics.hAlign = value;
        }
    }
};
